<template>
  <div class="user-panel user-statements">
    <header>Pozostałe oświadczenia dla banku</header>
    <div class="statement" v-for="statement in statements" :key="statement.id">
      {{ statement.label }}
      <button
        type="button"
        class="btn-link-inline"
        @click="statement.showFull = !statement.showFull"
      >{{ statement.showFull ? 'Zwiń' : 'Rozwiń'}}</button>
      <transition name="slide-up">
        <div v-show="statement.showFull" v-html="statement.content"></div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statements: [
        {
          id: 1,
          showFull: false,
          label: "Zapoznaj się z treścią oświadczeń",
          content: `
                        <ol>
                            <li>Administratorem danych osobowych jest mBank S.A. z siedzibą w Warszawie (00-850) przy ul.Prostej 18 (dalej: "Bank"). Oświadczenie gromadzone jest na potrzeby realizacji obowiązków Banku dotyczących identyfikacji Klientów będących podatnikami USA lub będących rezydentami państw uczestniczących*** na podstawie Ustawy FATCA i Ustawy CRS. Masz prawo dostępu do swoich danych oraz prawo do ich poprawiania.</li>
                            <li>Bank będzie przekazywał informacje znajdujące się w niniejszym oświadczeniu, informacje dotyczące Twojej osoby oraz o wszystkich rachunkach raportowanych do polskich organów podatkowych.</li>
                            <li>Raportowaniu na podstawie punktu 2 powyżej podlegają wyłącznie rachunki raportowane, tj. rachunki osób będących rezydentami podatkowymi państw innych niż Polska.</li>
                            <li>Jeśli korzystasz z usługi przyjmowania i przekazywania zleceń nabycia lub zbycia instrumentów finansowych, np. certyfikatów inwestycyjnych funduszy inwestycyjnych lub jednostek uczestnictwa funduszy inwestycyjnych, wówczas Bank może przekazać niniejsze oświadczenie do właściwych funduszy lub agentów transferowych działających w imieniu tychże funduszy, a w przypadku korzystania z usługi zarządzania portfelem instrumentów finansowych również do podmiotów wykonujących Twoje przyszłe zlecenia. Lista podmiotów znajduje się na stronie internetowej Banku.</li>
                            <li>Potwierdzam, że wszystkie dane, które złożyłem w niniejszym oświadczeniu są, zgodnie z moją najlepszą wiedzą, kompletne i prawdziwe.</li>
                            <li>Zobowiązuje się poinformować Bank o jakiejkolwiek zmianie okoliczności, które mają wpływ na moją rezydencję podatkową, lub powodują, że informacje zawarte w niniejszym oświadczeniu stają się nieaktualne. W takiej sytuacji złożę w Banku zaktualizowane oświadczenie dotyczące mojej rezydencji podatkowej w ciągu 30 dni od daty wystąpienia zmiany.</li>
                        </ol>
                    `
        },
        {
          id: 2,
          showFull: false,
          label: "**Definicja podatnika USA",
          content: `
                        <p>powinna być interpretowana zgodnie z przepisami Kodeksu Podatkowego USA (z ang. Internal Revenue Code) wedle którego podatnikiem USA jest osoba fizyczna spełniająca co najmniej jeden z warunków wymienionych poniżej:</p>
                        <ul>
                            <li>posiada obywatelstwo USA (również w przypadku jednoczesnego posiadania innego obywatelstwa);</li>
                            <li>prawo stałego pobytu w USA przez dowolny okres w danym roku (tzw. Zielona Karta);</li>
                            <li>dokonała wyboru amerykańskiej rezydencji dla celów podatkowych po spełnieniu warunków przewidzianych w przepisach USA;</li>
                            <li>przebywała w USA przez co najmniej 31 dni w ciągu roku podatkowego i jednocześnie łączna liczba dni, w których osoba ta przebywała w USA w ciągu bieżącego roku i 2 poprzednich lat kalendarzowych wynosi co najmniej 183 dni (ustalając łączną liczbę dni pobytu stosuje się mnożnik 1 dla liczby dni pobytu w roku bieżącym, 1/3 dla dni pobytu w roku poprzednim i 1/6 dla dni pobytu dwa lata wstecz co oznacza, że:
                                <br>1 dzień pobytu w roku bieżącym = 1 dzień do łącznej liczby dni pobytu;
                                <br>3 dni pobytu w roku poprzednim = 1 dzień do łącznej liczby dni pobytu;
                                <br>6 dni pobytu dwa lata wstecz = 1 dzień do łącznej liczby dni pobytu.
                            </li>
                        </ul>
                    `
        },
        {
          id: 3,
          showFull: false,
          label: "***Państwo uczestniczące",
          content: `
                        <ul>
                            <li>inne niż Rzeczpospolita Polska państwo członkowskie Unii Europejskiej,</li>
                            <li>inne niż Stany Zjednoczone Ameryki państwo lub terytorium, z którym Rzeczpospolita Polska zawarła porozumienie stanowiące podstawę automatycznej wymiany informacji o rachunkach raportowanych,</li>
                            <li>inne niż Stany Zjednoczone państwo lub terytorium, z którym Unia Europejska zawarła porozumienie stanowiące podstawę automatycznej wymiany informacji o rachunkach raportowanych wymienione w wykazie opublikowanym przez Komisję Europejską.</li>
                        </ul>
                    `
        }
      ]
    };
  }
};
</script>